// extracted by mini-css-extract-plugin
export default {"headingClass":"FAQs_headingClass__Ix92k","contentDiv":"FAQs_contentDiv__VPcpf","btnClass":"FAQs_btnClass__hHXS+"};